import Vue from "vue";
import Router from "vue-router";
import test from "@/components/timetable/test";
Vue.use(Router);
const originalPush1 = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush1.call(this, location).catch(err => err);
};
const originalPush2 = Router.prototype.replace;
Router.prototype.replace = function replace(location) {
  return originalPush2.call(this, location).catch(err => err);
};
export default new Router({
  routes: [
    {
      path: "/register/:tno",
      name: "register",
      component: () => import("@/components/register"),
      meta: { title: "学员注册" }
    },
    {
      path: "/registerOem/:tno",
      name: "registerOem",
      component: () => import("@/components/registerOem"),
      meta: { title: "学员注册" }
    },
    {
      path: "/login/:tenantNo",
      name: "login",
      component: () => import("@/components/login/login"),
      meta: { title: "学员登录" }
    },
    {
      path: "/loginSimple/:tenantNo",
      name: "loginSimple",
      component: () => import("@/components/loginSimple/index"),
      meta: { title: "学员登录" }
    },
    {
      path: "/loginFast/:tenantNo",
      name: "loginFast",
      component: () => import("@/components/loginFast"),
      meta: { title: "学员登录" }
    },
    {
      path: "/loginUnion/:unionNo",
      name: "loginUnion",
      component: () => import("@/components/loginUnion"),
      meta: { title: "学员登录" }
    },
    {
      path: "/loginTool/:tenantNo",
      name: "loginTool",
      component: () => import("@/components/loginTool/index"),
      meta: { title: "登录中..." }
    },
    {
      path: "/homePage",
      name: "homePage",
      component: () => import("@/components/homePage/homePage"),
      meta: {
        keepAlive: true
      }
    },
    {
      path: "/test",
      name: "test",
      component: () => import("@/components/test")
    },
    {
      path: "/loginAssistant",
      name: "loginAssistant",
      component: () => import("@/components/loginAssistant"),
      meta: { title: "学员登录" }
    },
    {
      path: "/elegant",
      name: "elegant",
      component: () => import("@/components/homePage/elegant"),
      meta: { title: "学员风采" }
    },
    {
      path: "/myself",
      name: "myself",
      component: () => import("@/components/myself/myself"),
      meta: { title: "个人中心" }
    },
    {
      path: "/timetable",
      name: "timetable",
      component: () => import("@/components/timetable/timetable"),
      meta: { title: "课表", keepAlive: true }
    },
    {
      path: "/evaluate",
      name: "evaluate",
      component: () => import("@/components/homePage/evaluate"),
      meta: { title: "评价老师", keepAlive: true }
    },
    {
      path: "/evaluateDetails/:id",
      name: "evaluateDetails",
      component: () => import("@/components/homePage/evaluateDetails"),
      meta: { title: "评价" }
    },
    {
      path: "/leave",
      name: "leave",
      component: () => import("@/components/leave"),
      meta: { title: "请假审批", keepAlive: true }
    },
    {
      path: "/tryClassMgr",
      name: "tryClassMgr",
      component: () => import("@/components/tryClassMgr"),
      meta: { title: "试听申请", keepAlive: true }
    },
    {
      path: "/tryClassAdd",
      name: "tryClassAdd",
      component: () => import("@/components/tryClassMgr/tryClassAdd"),
      meta: { title: "试听申请" }
    },
    {
      path: "/tryClassDetail/:id",
      name: "tryClassDetail",
      component: () => import("@/components/tryClassMgr/tryClassDetail"),
      meta: { title: "试听详情" }
    },
    {
      path: "/startLeave",
      name: "startLeave",
      component: () => import("@/components/leave/startLeave"),
      meta: { title: "发起请假" }
    },
    {
      path: "/leaveDetails/:id",
      name: "leaveDetails",
      component: () => import("@/components/leave/leaveDetails"),
      meta: { title: "请假详情" }
    },
    {
      path: "/homework",
      name: "homework",
      component: () => import("@/components/homePage/homework"),
      meta: { title: "作业", keepAlive: true }
    },
    {
      path: "/homeworkDetails",
      name: "homeworkDetails",
      component: () => import("@/components/homePage/homeworkDetails"),
      meta: { title: "作业详情" }
    },
    {
      path: "/archivesDetails",
      name: "archivesDetails",
      component: () => import("@/components/myself/archivesDetails")
    },
    {
      path: "/archivesDetails2",
      name: "archivesDetails2",
      component: () => import("@/components/myself/archivesDetails2")
    },
    {
      path: "/userinfo",
      name: "userinfo",
      component: () => import("@/components/myself/userinfo"),
      meta: { title: "个人信息" }
    },
    {
      path: "/classRecord",
      name: "classRecord",
      component: () => import("@/components/myself/classRecord"),
      meta: { title: "上课记录" }
    },
    {
      path: "/courseConsumeLog",
      name: "courseConsumeLog",
      component: () => import("@/components/myself/courseConsumeLog"),
      meta: { title: "课消记录" }
    },
    {
      path: "/gift",
      name: "gift",
      component: () => import("@/components/homePage/gift"),
      meta: { title: "礼品兑换", keepAlive: true }
    },
    {
      path: "/archives",
      name: "archives",
      component: () => import("@/components/myself/archives"),
      meta: { title: "我的收藏" }
    },
    {
      path: "/curriculum",
      name: "curriculum",
      component: () => import("@/components/myself/curriculum"),
      meta: { title: "报读课程" }
    },
    {
      path: "/timetableDetail/:id",
      name: "timetableDetail",
      component: () => import("@/components/timetable/timetableDetail"),
      meta: { title: "课表详情" }
    },
    {
      path: "/giftDetail/:id",
      name: "giftDetail",
      component: () => import("@/components/homePage/giftDetail"),
      meta: { title: "礼品详情" }
    },
    {
      path: "/studentList",
      name: "studentList",
      component: () => import("@/components/myself/studentList"),
      meta: { title: "学员列表" }
    },
    {
      path: "/studentEdit/:id",
      name: "studentEdit",
      component: () => import("@/components/myself/studentEdit"),
      meta: { title: "修改资料" }
    },
    {
      path: "/classRecordDetail",
      name: "classRecordDetail",
      component: () => import("@/components/myself/classRecordDetail"),
      meta: { title: "上课记录详情" }
    },
    {
      path: "/payhistory",
      name: "payhistory",
      component: () => import("@/components/myself/payhistory"),
      meta: { title: "消费记录" }
    },
    {
      path: "/orderDetail/:id",
      name: "orderDetail",
      component: () => import("@/components/myself/orderDetail"),
      meta: { title: "消费记录详情" }
    },
    {
      path: "/orderReturnDetail/:id",
      name: "orderReturnDetail",
      component: () => import("@/components/myself/orderReturnDetail"),
      meta: { title: "消费记录详情" }
    },
    {
      path: "/transferCoursesDetail/:id",
      name: "transferCoursesDetail",
      component: () => import("@/components/myself/transferCoursesDetail"),
      meta: { title: "消费记录详情" }
    },
    {
      path: "/coupon",
      name: "coupon",
      component: () => import("@/components/myself/coupon"),
      meta: { title: "优惠券" }
    },
    {
      path: "/couponDetail",
      name: "couponDetail",
      component: () => import("@/components/myself/couponDetail"),
      meta: { title: "优惠券详情" }
    },
    {
      path: "/integralRecord",
      name: "integralRecord",
      component: () => import("@/components/myself/integralRecord"),
      meta: { title: "积分记录" }
    },
    {
      path: "/giftRecord",
      name: "giftRecord",
      component: () => import("@/components/myself/giftRecord"),
      meta: { title: "礼品兑换记录" }
    },
    {
      path: "/afterClass",
      name: "afterClass",
      component: () => import("@/components/myself/afterClass"),
      meta: { title: "学员详情" }
    },
    {
      path: "/WxMessage",
      name: "WxMessage",
      component: () => import("@/components/myself/WxMessage"),
      meta: { title: "微信消息" }
    },
    {
      path: "/WxMessageDetail/:id",
      name: "WxMessageDetail",
      component: () => import("@/components/myself/WxMessageDetail")
    },
    {
      path: "/WxMessageDetail2",
      name: "WxMessageDetail2",
      component: () => import("@/components/myself/WxMessageDetail2")
    },
    {
      path: "/loginOut",
      name: "loginOut",
      component: () => import("@/components/myself/loginOut"),
      meta: { title: "温馨提示" }
    },
    {
      path: "/checkWork/:id",
      name: "checkWork",
      component: () => import("@/components/myself/checkWork"),
      meta: { title: "考勤详情" }
    },
    {
      path: "/checkWork2",
      name: "checkWork2",
      component: () => import("@/components/myself/checkWork2"),
      meta: { title: "考勤详情" }
    },
    {
      path: "/balance/:id",
      name: "balance",
      component: () => import("@/components/myself/balance/index"),
      meta: { title: "余额" }
    },
    {
      path: "/rechargeRules",
      name: "rechargeRules",
      component: () =>
        import("@/components/myself/balance/rechargeRules/index"),
      meta: { title: "充值规则" }
    },
    {
      path: "/appointment",
      name: "appointment",
      component: () => import("@/components/appointment/index"),
      meta: { title: "在线约课" }
    },
    {
      path: "/appointmentOEM",
      name: "appointmentOEM",
      component: () => import("@/components/appointmentOEM"),
      meta: { title: "在线约课" }
    },
    {
      path: "/myAppointmentDetail",
      name: "myAppointmentDetail",
      component: () => import("@/components/appointment/myAppointmentDetail"),
      meta: { title: "在线约课" }
    },
    {
      path: "/reservationLog",
      name: "reservationLog",
      component: () => import("@/components/appointment/reservationLog"),
      meta: { title: "约课记录" }
    },
    {
      path: "/selectStudent",
      name: "selectStudent",
      component: () => import("@/components/appointment/selectStudent"),
      meta: { title: "选择学员" }
    },
    {
      path: "/recommend",
      name: "recommend",
      component: () => import("@/components/myself/recommend/index"),
      meta: { title: "推荐有奖" }
    },
    {
      path: "/unbindStudent",
      name: "unbindStudent",
      component: () => import("@/components/common/unbindStudent/index"),
      meta: { title: "未绑定学员" }
    },
    {
      path: "/michome",
      name: "michome",
      component: () => import("@/components/myself/michome/index"),
      meta: { title: "微官网", keepAlive: true }
    },
    {
      path: "/michome/onePage",
      name: "onePage",
      component: () => import("@/components/myself/michome/onePage/index")
    },
    {
      path: "/michome/listPage",
      name: "listPage",
      component: () => import("@/components/myself/michome/listPage/index")
    },
    {
      path: "/michome/detailPage",
      name: "detailPage",
      component: () => import("@/components/myself/michome/detailPage/index")
    },
    {
      path: "/michome/supplyOrder",
      name: "supplyOrder",
      component: () => import("@/components/myself/michome/supplyOrder/index"),
      meta: { title: "预约成功" }
    },
    {
      path: "/mallhome",
      name: "mallhome",
      component: () => import("@/components/mallhome/index"),
      meta: { title: "在线商城" }
    },
    {
      path: "/mallhomeList",
      name: "mallhomeList",
      component: () => import("@/components/mallhomeList/index"),
      meta: { title: "在线商城" }
    },
    {
      path: "/malldetail",
      name: "malldetail",
      component: () => import("@/components/malldetail/index"),
      meta: { title: "商品详情" }
    },
    {
      path: "/sureOrder",
      name: "sureOrder",
      component: () => import("@/components/malldetail/sureOrder/index"),
      meta: { title: "确认订单" }
    },
    {
      path: "/tryApplyPay",
      name: "tryApplyPay",
      component: () => import("@/components/tryApplyPay"),
      meta: { title: "预约试听" }
    },
    {
      path: "/paySuc",
      name: "paySuc",
      component: () => import("@/components/paySuc/index"),
      meta: { title: "支付成功" }
    },
    {
      path: "/mallOrder",
      name: "mallOrder",
      component: () => import("@/components/mallOrder/index"),
      meta: { title: "商城订单" }
    },
    {
      path: "/visitorLogin",
      name: "visitorLogin",
      component: () => import("@/components/visitorLogin/index"),
      meta: { title: "学员登录" }
    },
    {
      path: "/checkRecord",
      name: "checkRecord",
      component: () => import("@/components/myself/checkRecord/index"),
      meta: { title: "考勤记录" }
    },
    {
      path: "/activityLib",
      name: "activityLib",
      component: () => import("@/components/activityLib/index"),
      meta: { title: "机构活动" }
    },
    {
      path: "/my_activity",
      name: "my_activity",
      component: () => import("@/components/activityLib/my"),
      meta: { title: "我的活动" }
    },
    {
      path: "/album",
      name: "album",
      component: () => import("@/components/album/index"),
      meta: { title: "电子相册" }
    },
    // { path: '/albumDetail', name: 'albumDetail', component: () => import('@/components/album/albumDetail/index'), meta: { title: '电子相册详情' } },
    {
      path: "/commentRecord",
      name: "commentRecord",
      component: () => import("@/components/commentRecord/index"),
      meta: { title: "点评记录" }
    },
    {
      path: "/commentRecordDetail",
      name: "commentRecordDetail",
      component: () =>
        import("@/components/commentRecord/commentRecordDetail/index"),
      meta: { title: "点评记录详情" }
    },
    {
      path: "/achievementList",
      name: "achievementList",
      component: () => import("@/components/achievement/achievementList"),
      meta: { title: "成绩单" }
    },
    {
      path: "/achievementDetail",
      name: "achievementDetail",
      component: () => import("@/components/achievement/achievementDetail"),
      meta: { title: "成绩单详情" }
    },
    {
      path: "/achievementDetail2",
      name: "achievementDetail2",
      component: () => import("@/components/achievement/achievementDetail2"),
      meta: { title: "成绩单详情" }
    },
    {
      path: "/download/:url",
      name: "download",
      component: () => import("@/components/common/download"),
      meta: { title: "点击下载文件" }
    },
    {
      path: "/homeworkGood/:id",
      name: "homeworkGood",
      component: () => import("@/components/homepage/homeworkGood"),
      meta: { title: "精选作业" }
    },
    {
      path: "/textBookMy",
      name: "textBookMy",
      component: () => import("@/components/textBookMy"),
      meta: { title: "我的教材" }
    },
    {
      path: "/textBookList",
      name: "textBookList",
      component: () => import("@/components/textBookMy2/textBookMyList"),
      meta: { title: "我的教材" }
    },
    {
      path: "/textbookDetail",
      name: "textbookDetail",
      component: () => import("@/components/textBookMy2/textBookMyDetail"),
      meta: { title: "我的教材" }
    },
    {
      path: "/textbookDetailHead",
      name: "textbookDetailHead",
      component: () => import("@/components/textBookMyHead"),
      meta: { title: "我的教材" }
    },
    {
      path: "/wxMsg",
      name: "wxMsg",
      component: () => import("@/components/wxMsg"),
      meta: { title: "微信消息" }
    },
    {
      path: "/galleryHome",
      name: "galleryHome",
      component: () => import("@/components/galleryHome/index"),
      meta: { title: "美术馆" }
    },
    {
      path: "/galleryImage",
      name: "galleryImage",
      component: () => import("@/components/galleryHome/galleryImage/index")
    },
    {
      path: "/galleryList",
      name: "galleryList",
      component: () => import("@/components/galleryList"),
      meta: { title: "美术馆" }
    },
    {
      path: "/couponCanOnlineGet",
      name: "couponCanOnlineGet",
      component: () => import("@/components/couponCanOnlineGet"),
      meta: { title: "在线领券" }
    },
    {
      path: "/superformGate",
      name: "superformGate",
      component: () => import("@/components/superformGate"),
      meta: { title: "超级表单" }
    },
    {
      path: "/poster",
      name: "poster",
      component: () => import("@/components/galleryHome/poster/index"),
      meta: { title: "海报分享" }
    },
    {
      path: "/autographAlbum",
      name: "autographAlbum",
      component: () => import("@/components/autographAlbum"),
      meta: { title: "纪念册分享" }
    },
    { path: "/test", name: "test", component: test, meta: { title: "测试" } },
    {
      path: "/grow",
      name: "grow",
      component: () => import("@/components/grow/index"),
      meta: { title: "成长" }
    },
    {
      path: "/growDetail/:id",
      name: "grow",
      component: () => import("@/components/growDetail/index"),
      meta: { title: "成长档案详情" }
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js